import IFolder from './IFolder';
import IGroup from './IGroup';
import IUserData, { IRoomPermissions } from './IUserData';

export default interface IDataRoom {
  agreement_enable?: any;
  agreement_file?: any;
  agreement_id?: any;
  name: string;
  description: string;
  created_at: number | string | null;
  permissions?: IRoomPermissions;
  id: string;
  user_status?: number;
  owner_id: string;
  available_users?: IUserData[];
  folders: IFolder[];
  groups?: IGroup[];
  template_id?: string | undefined;
  custom_url?: string | null;
  user_status_change_at?: string | number;
  status?: any;
  watermark_enabled: boolean;
  last_action_timestamp: any;
  new_count?: number;
  message_count?: number;
  unviewed_amount?: number;
  documents_amount?: number;
  is_admin?: boolean;
  invite_status?: number;
  rooms_constraints: IConstrains;
  tariff?: {
    id?: string;
    tariff_name?: string;
    status?: string;
    tariff_ends_at?: string;
    constraints?: any;
    cost?: number;
    duration?: number;
    duration_unit?: string;
    last_payment_intent?: any;
    tariff_history_id?: string;
    currency?: string;
    type?: string;
  };
  // tariff_lifetime_to?: string | null;
  lives_to?: string | null;
  invite_id?: string;
  access_terms_status?: string;
  invited_at?: any;
  need_to_update_terms?: boolean;
  access_terms_enabled?: boolean;
  room_status?: string;
  is_expired?: boolean;
  is_blocked?: boolean;
  has_childs?: boolean;
  system_status?: 'new' | 'active' | 'expired';
}

interface IConstrains {
  max_members_amount: number | null;
  members_amount_left: number | null;
  max_space: number | null;
  available_space: number | null;
  members_amount: number | null;
  total_document_size: number | null;
}

export enum ERoomFilters {
  All = 'all',
  Owner = 'owner',
  Administrator = 'administrator',
  Member = 'member'
}
